import { render, staticRenderFns } from "./messageWindow.vue?vue&type=template&id=8cf03cd0&"
import script from "./messageWindow.vue?vue&type=script&lang=js&"
export * from "./messageWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports